import { createUseStyles } from 'react-jss'
import { typography } from '@dentalux/ui-library-core'
import { forPhoneOnly } from 'src/config/mediaQueries'
import { Theme } from '@mui/material/styles'

export const useStyles = createUseStyles((theme: Theme) => ({
  headerTitle: {
    ...typography['Lato H4'],
    textAlign: 'center',
    padding: '0px 16px',
    marginBottom: 24,
    [forPhoneOnly]: {
      fontSize: '20px',
    },
  },
  headerWrapper: {
    zIndex: 10,
    padding: [32, 0, 24],
    [forPhoneOnly]: {
      padding: [24, 0, 12],
    },
  },
  multipleClinicsWrapper: {
    position: 'sticky',
    background: theme.palette.common.white,
    top: 0,
    boxShadow: '0px 1px 1px 0px #2121210F, 0px 0px 10px 0px #2121211A',
    marginBottom: 32,
    padding: '8px 0',
    [forPhoneOnly]: {
      marginBottom: 16,
    },
  },
  headerContainer: {
    maxWidth: '544px',
    margin: '0 auto',
    [forPhoneOnly]: {
      padding: [0, 16],
    },
  },
}))
